import React from 'react';
import { LoadingDots } from 'site-modules/shared/components/loading-dots/loading-dots';

import './dealer-fees-modal-loader.scss';

export function DealerFeesModalLoader() {
  return (
    <div className="dealer-fees-modal-loader d-flex align-items-center justify-content-center">
      <LoadingDots />
    </div>
  );
}
